package playground.gradient.data

internal sealed class Gradient(val type: String) {
    data object Linear : Gradient("Linear")
    data object Radial : Gradient("Radial")
    data object Sweep : Gradient("Sweep")
}